module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "container"
  }, [(_vm.projectFiles.length > 0) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFilePath),
      expression: "newFilePath"
    }],
    domProps: {
      "value": (_vm.newFilePath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newFilePath = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function () {
        _vm.newFile({
          path: _vm.newFilePath
        })
      }
    }
  }, [_vm._v("Add File")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.compiling
    },
    on: {
      "click": function () {
        _vm.compileFiles()
      }
    }
  }, [_vm._v("Compile Files")]), _vm._v(" "), (!_vm.iwindow && !_vm.compiling) ? _c('button', {
    on: {
      "click": function () {
        _vm.openWindow()
      }
    }
  }, [_vm._v("OpenWindow")]) : _vm._e(), _vm._v(" "), (_vm.iwindow) ? _c('button', {
    on: {
      "click": function () {
        _vm.closeWindow()
      }
    }
  }, [_vm._v("closeWindow")]) : _vm._e(), _vm._v(" "), (!_vm.iframer && !_vm.compiling) ? _c('button', {
    on: {
      "click": function () {
        _vm.openiFrame()
      }
    }
  }, [_vm._v("OpenIframe")]) : _vm._e(), _vm._v(" "), (_vm.iframer) ? _c('button', {
    on: {
      "click": function () {
        _vm.closeiFrame()
      }
    }
  }, [_vm._v("closeIframe")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.compiling),
      expression: "compiling"
    }]
  }, [_vm._v("Compiling")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((this.userBackups), function(user, userKey) {
    return _c('span', {
      key: userKey
    }, [_c('select', {
      on: {
        "change": _vm.viewProj
      }
    }, _vm._l((user), function(backup, backupKey) {
      return _c('option', {
        key: backupKey,
        domProps: {
          "value": backup.data
        }
      }, [_vm._v(_vm._s(backup.date) + " - " + _vm._s(backup.by))])
    })), _vm._v(" "), _c('br')])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.exportProjectFiles
    }
  }, [_vm._v("Backup Project")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.importProjectFiles
    }
  }), _vm._v(" "), _c('draggable', {
    attrs: {
      "options": {
        group: 'people'
      }
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      },
      "change": function () {
        _vm.compileFiles()
      }
    },
    model: {
      value: (_vm.projectFiles),
      callback: function($$v) {
        _vm.projectFiles = $$v
      },
      expression: "projectFiles"
    }
  }, _vm._l((_vm.projectFiles), function(pFile, pfKey) {
    return _c('div', {
      key: pfKey
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pFile.path),
        expression: "pFile.path"
      }],
      staticStyle: {
        "font-size": "16px",
        "width": "300px"
      },
      attrs: {
        "disabled": _vm.checkDisable(pFile.path)
      },
      domProps: {
        "value": (pFile.path)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(pFile, "path", $event.target.value)
        }, function($event) {
          _vm.updateCurrentObj()
        }]
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.setFile(pFile)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.checkDisable(pFile.path)),
        expression: "!checkDisable(pFile.path)"
      }],
      on: {
        "click": function($event) {
          _vm.removeFile(_vm.projectFiles, pfKey)
        }
      }
    }, [_vm._v("remove")])])
  })), _vm._v(" "), (_vm.iframer) ? _c('iframe', {
    ref: "iframer",
    staticClass: "iframe",
    attrs: {
      "width": "700",
      "height": "500",
      "src": _vm.iframer,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentFile) ? _c('ACE', {
    attrs: {
      "filepath": _vm.currentFile.path,
      "theme": "chrome",
      "width": "100%",
      "height": _vm.ace.height
    },
    on: {
      "save": function () {
        _vm.compileFiles();
        _vm.saveToCloud();
      },
      "input": function (value) {
        _vm.isDirty = true;
        _vm.updateCurrentObj();
      }
    },
    model: {
      value: (_vm.currentFile.src),
      callback: function($$v) {
        _vm.$set(_vm.currentFile, "src", $$v)
      },
      expression: "currentFile.src"
    }
  }) : _vm._e()], 2) : _c('div', [_vm._v("\n    Loading......\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-884efca4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aviasim/Building.vue
// module id = 304
// module chunks = 3